module.exports = __webpack_public_path__ + "img/modal-upload-header.8b3902be.svg";